import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

const VillaEter = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleReserveClick = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const reserveSection = document.getElementById('reserve');
      if (reserveSection) {
        reserveSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const galleryImages = [
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/68d901d342f8c2215c98868effd346c4.jpeg',
      alt: 'Villa Eter - Beautiful backyard with pool and colorful houses'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/182f94a3f49b2c01e094812748877046.jpeg',
      alt: 'Villa Eter - Stylish living area with artistic wall design'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/ce837dc962035aa82fd26eedf09795c6.jpeg',
      alt: 'Villa Eter - Bright and serene bedroom with natural light'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/10e1de5927539d46de51ae960de57bf1.jpeg',
      alt: 'Villa Eter - Elegant bedroom interior'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/ab607dd5f5b0aa67525c2904ffc67bae.jpeg',
      alt: 'Villa Eter - Terrace view with pink balustrade and pool'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/ac9592faf8dc51626198a5d5f19d9705.jpeg',
      alt: 'Villa Eter - Peaceful bedroom with twin beds and natural light'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/682c1df2a0076e565e688b95f5f12115.jpeg',
      alt: 'Villa Eter - Modern fully equipped kitchen'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <section className="relative h-[70vh] min-h-[500px]">
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/68d901d342f8c2215c98868effd346c4.jpeg"
            alt="Villa Eter"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40"></div>
        </div>
        <div className="relative h-full flex items-center justify-center text-center px-4">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-6">
              Villa Eter
            </h1>
            <p className="text-xl md:text-2xl text-white/95 mb-8 leading-relaxed">
              Connect with the infinite. Private pool, meditation garden, and stunning sunset views for deep contemplation.
            </p>
            <div className="flex items-center justify-center gap-6 text-white/90 text-lg">
              <div className="flex items-center">
                <i className="ri-user-line mr-2 text-xl"></i>
                <span>Sleeps 4-6 guests</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Villa Details */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            {/* Left Column - Description */}
            <div>
              <h2 className="text-4xl font-serif font-bold text-gray-900 mb-6">
                Your Gateway to Infinite Peace
              </h2>
              <div className="prose prose-lg text-gray-600 space-y-4">
                <p>
                  Villa Eter represents the fifth element—the ethereal space that connects all things. 
                  This exceptional villa offers the most expansive accommodations in our retreat, 
                  perfect for those seeking a profound connection with the universe and themselves.
                </p>
                <p>
                  The crown jewel of Villa Eter is its private infinity pool that seems to merge 
                  with the horizon, creating a seamless connection between earth and sky. The 
                  meditation garden, carefully designed with native Canarian plants and natural 
                  stone pathways, provides multiple secluded spots for contemplation and practice.
                </p>
                <p>
                  As the sun sets, the villa transforms into a sanctuary of golden light. The 
                  west-facing terraces offer unobstructed views of the Atlantic Ocean, where you 
                  can witness breathtaking sunsets that paint the sky in shades of amber, rose, 
                  and violet—a daily reminder of life's infinite beauty.
                </p>
              </div>

              {/* Amenities */}
              <div className="mt-12">
                <h3 className="text-2xl font-serif font-bold text-gray-900 mb-6">
                  Villa Amenities
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-2xl text-teal-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Private Infinity Pool</h4>
                      <p className="text-sm text-gray-600">Heated, with ocean views</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-2xl text-teal-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Meditation Garden</h4>
                      <p className="text-sm text-gray-600">Multiple contemplation areas</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-2xl text-teal-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">3 Bedrooms</h4>
                      <p className="text-sm text-gray-600">King & queen beds, luxury linens</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-2xl text-teal-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">2.5 Bathrooms</h4>
                      <p className="text-sm text-gray-600">Rain showers, organic toiletries</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-2xl text-teal-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Sunset Terraces</h4>
                      <p className="text-sm text-gray-600">Multiple outdoor lounging areas</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-2xl text-teal-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Gourmet Kitchen</h4>
                      <p className="text-sm text-gray-600">Fully equipped, premium appliances</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-2xl text-teal-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Yoga Space</h4>
                      <p className="text-sm text-gray-600">Private indoor practice area</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-2xl text-teal-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Smart Home System</h4>
                      <p className="text-sm text-gray-600">Climate, lighting, sound control</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Image Gallery */}
            <div>
              <div className="grid grid-cols-1 gap-6">
                {galleryImages.map((image, index) => (
                  <div 
                    key={index}
                    className="relative overflow-hidden rounded-2xl shadow-lg group"
                  >
                    <div className="relative h-80 w-full">
                      <img
                        src={image.url}
                        alt={image.alt}
                        className="w-full h-full object-cover object-top transform transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Special Features */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-serif font-bold text-gray-900 text-center mb-16">
            What Makes Villa Eter Special
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="w-20 h-20 mx-auto mb-6 bg-teal-100 rounded-full flex items-center justify-center">
                <i className="ri-water-flash-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Infinity Pool Experience
              </h3>
              <p className="text-gray-600">
                Your private heated pool creates a seamless visual connection with the ocean, 
                perfect for morning meditation swims or evening stargazing floats.
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 mx-auto mb-6 bg-teal-100 rounded-full flex items-center justify-center">
                <i className="ri-sun-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Sunset Sanctuary
              </h3>
              <p className="text-gray-600">
                West-facing terraces provide front-row seats to nature's daily masterpiece. 
                Watch the sun melt into the Atlantic from multiple vantage points.
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 mx-auto mb-6 bg-teal-100 rounded-full flex items-center justify-center">
                <i className="ri-plant-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Sacred Garden Spaces
              </h3>
              <p className="text-gray-600">
                Winding stone paths lead through native flora to hidden meditation nooks, 
                each offering a unique perspective for contemplation and connection.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-serif font-bold text-gray-900 mb-6">
            Ready to Experience Villa Eter?
          </h2>
          <p className="text-lg text-gray-600 mb-10 leading-relaxed">
            This exceptional villa books quickly due to its unique features and spacious accommodations. 
            Reserve your dates now to secure your sanctuary of infinite peace.
          </p>
          <button
            onClick={handleReserveClick}
            className="inline-flex items-center px-10 py-4 bg-teal-600 text-white text-lg font-semibold rounded-full hover:bg-teal-700 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Reserve Villa Eter
            <i className="ri-arrow-right-line ml-2 text-xl"></i>
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default VillaEter;